import React, { useState, useEffect } from "react";
import { CompactTable } from "@table-library/react-table-library/compact";
import DeleteIcon from "@mui/icons-material/Delete";

import { useTheme } from "@table-library/react-table-library/theme";
import { getTheme } from "@table-library/react-table-library/baseline";
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell,
} from "@table-library/react-table-library/table";

// import JS files
import MuiPagination from "../mui/MuiPagination";

// import others files

const PanelTable = ({
  labels,
  items,
  data,
  setItem,
  apiReFetch,
  openStateFunc,
  paginationPageInfo,
  setPaginationPageInfo,
}) => {
  const theme = useTheme([
    getTheme(),
    {
      Table: `min-width:1024px;`,
      Header: `
      direction:rtl;
      text-align:center;
      `,
      HeaderRow: `
        background-color: #1c4870;
        color:#fff;
      `,
      HeaderCell: `
      text-align:center;
      direction:rtl;

      `,
      Row: `
        &:nth-of-type(odd) {
          background-color: #f8f8f8;
        }
        &:nth-of-type(even) {
          background-color: #fff;
        }
      `,
      Cell: `
      text-align:center;
      direction:rtl;
      cursor:pointer;
      `,
    },
  ]);

  const onChangePage = (e, page) => {
    console.log(page);
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setItem({ nodes: [] });
    apiReFetch.reFetch();
  };

  const handleOpen = (i, tableListIndex, item) => {
    i.func(tableListIndex, item);
  };
  const handleOpenStateFunc = (i, tableListIndex, item) => {
    openStateFunc((before) => !before);
    i.func(tableListIndex, item);
  };
  return (
    <>
      {Object.keys(data).length <= 0 ? (
        <p></p>
      ) : (
        <>
          <div className="overflow-scroll mt-4 w-[85vw] md:w-auto m-auto">
            <Table
              data={data}
              theme={theme}
              layout={{ horizontalScroll: true }}
            >
              {(tableList) => (
                <>
                  <Header>
                    <HeaderRow>
                      {labels.map((it, ind) => {
                        return <HeaderCell>{it}</HeaderCell>;
                      })}
                    </HeaderRow>
                  </Header>

                  <Body>
                    {tableList.map((item, tableListIndex) => {
                      return (
                        <Row>
                          {items.map((i, d) => {
                            if (i.type == "data")
                              if (i.hasIcon)
                                return (
                                  <Cell>
                                    <a
                                      target="_blank"
                                      download
                                      href={item[i.key]}
                                    >
                                      {i.icon}
                                    </a>
                                  </Cell>
                                );
                              else return <Cell>{item[i.key]}</Cell>;
                            else if (i.type == "depth")
                              return (
                                <Cell>
                                  {
                                    item[i.key.split(".")[1]][
                                      i.key.split(".")[2]
                                    ]
                                  }
                                </Cell>
                              );
                            else if (i.type == "action")
                              return (
                                <Cell
                                  onClick={() =>
                                    openStateFunc
                                      ? handleOpenStateFunc(
                                          i,
                                          tableListIndex,
                                          item
                                        )
                                      : handleOpen(i, tableListIndex, item)
                                  }
                                >
                                  {i.hasIcon ? i.icon : undefined}
                                </Cell>
                              );
                          })}
                          ;
                        </Row>
                      );
                    })}
                  </Body>
                </>
              )}
            </Table>
          </div>
          <div className="mt-4 flex justify-center">
            <MuiPagination
              onChangePage={onChangePage}
              count={Math.ceil(
                paginationPageInfo.count / paginationPageInfo.pageSize
              )}
            />
          </div>
        </>
      )}
    </>
  );
};

export default PanelTable;
